import ConcurrentFields from './ConcurrentAllFields'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.zen_report.concurrent_table.fields", ConcurrentFields),
            sortOrder: [
                {
                    field: 'similarTagsCount',
                    direction: 'desc'
                },
            ],
            additionalActions: [],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
